import {LOCO_TYPE} from "../../../constants/Constants";
import BaseLocomotive from "./BaseLocomotive";

class Locomotive extends BaseLocomotive
{
    constructor(parentStation, id, state)
    {
        super(parentStation, id, state, 1);
        this.movementType = LOCO_TYPE;
    }
}

export default Locomotive;